<template>
  <div class="g-content my-info">
    <div class="my-title" v-auth="['auth_my_edit']" v-if="!isSuperAdmin">
      {{ $t('my_base_title') }}
    </div>
    <div class="my-form " v-auth="['auth_my_edit']" v-if="!isSuperAdmin">
      <a-form-model
        :model="myform"
        :rules="baseFormRules"
        ref="formElementBase"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <!-- 用户名 -->
        <a-form-model-item :label="$t('my_form_username')" prop="name">
          <a-input v-model="myform.name" disabled />
        </a-form-model-item>

        <!-- 角色 -->
        <a-form-model-item :label="$t('my_form_role')" prop="roleName">
          <a-input v-model="myform.roleName" disabled />
        </a-form-model-item>

        <!-- 所属客户 -->
        <a-form-model-item :label="$t('user_form_owner')" prop="customerName">
          <a-input v-model="myform.customerName" disabled />
        </a-form-model-item>

        <a-form-model-item :label="$t('my_form_avatar')" prop="avatar" style="width:100%;">
          <UploadOSS
            :value="myform.avatar"
            :manuallyUpload="false"
            @change="
              fileList => {
                myform.avatar = fileList || [];
              }
            "
            :maxCount="1"
            ref="uploadFile"
            uploadDirInOSS="images"
            uploadType="image"
          />
        </a-form-model-item>

        <!-- 昵称 -->
        <a-form-model-item :label="$t('my_form_nickname')" prop="nickName">
          <a-input v-model="myform.nickName" :placeholder="$t('my_form_nickname_placeholder')" />
        </a-form-model-item>

        <!-- 联系 -->
        <a-form-model-item :label="$t('my_form_contact')" prop="contact">
          <a-input v-model="myform.contact" :placeholder="$t('my_form_contact_placeholder')" />
        </a-form-model-item>

        <a-form-model-item label=" " :colon="false" style="text-align:right">
          <a-button
            type="primary"
            style="margin-top:15px"
            @click="updateMyBaseInfo"
            :loading="baseFormLoading"
            :disabled="emailFormLoading || passwordFormLoading"
          >
            {{ $t('my_base_btn') }}
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="my-hr" v-auth="['auth_my_email']" v-if="!isSuperAdmin"></div>

    <div class="my-title" v-auth="['auth_my_email']">
      {{ $t('my_email_title') }}
      <span>
        {{ $t('my_email_tips') }}
      </span>
    </div>
    <div class="my-form" v-auth="['auth_my_email']">
      <a-form-model
        :model="myform"
        :rules="updateEmailRules"
        ref="formElementEmail"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item :label="$t('my_form_email')" prop="email">
          <a-input v-model="myform.email" :placeholder="$t('my_form_email_placeholder')" />
        </a-form-model-item>

        <a-form-model-item label=" " :colon="false" style="text-align:right">
          <a-button
            type="primary"
            style="margin-top:15px"
            :loading="emailFormLoading"
            :disabled="baseFormLoading || passwordFormLoading"
            @click="updateMyEmailConfirmPassword"
          >
            {{ $t('my_email_btn') }}
          </a-button>
        </a-form-model-item>
      </a-form-model>

      <!-- 输入帐号密码 -->
      <a-modal
        :title="$t('my_email_password_title')"
        :visible="visible"
        @ok="updateMyEmail"
        @cancel="handleCancel"
        :afterClose="handleCancel"
        destroyOnClose
        :confirmLoading="emailFormLoading"
        :cancelButtonProps="{
          props: {
            disabled: emailFormLoading,
          },
        }"
      >
        <a-form-model-item
          :label="$t('my_email_password')"
          prop="password"
          :help="$t('my_email_password_help')"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 14 }"
          ref="updateEmailPassword"
        >
          <a-input-password type="password" v-model="myform.password" />
        </a-form-model-item>
      </a-modal>
    </div>
    <div class="my-hr" v-auth="['auth_my_password']" v-if="!isSuperAdmin"></div>
    <div class="my-title" v-auth="['auth_my_password']" v-if="!isSuperAdmin">
      {{ $t('my_password') }}
      <span>
        <!-- 密码修改完成后，您将需要使用新密码重新登录 -->
        {{ $t('my_password_help') }}
      </span>
    </div>
    <div
      class="my-form"
      style="margin-bottom:40px;"
      v-auth="['auth_my_password']"
      v-if="!isSuperAdmin"
    >
      <a-form-model
        :model="myform"
        :rules="updatePasswordRules"
        ref="formElementPassword"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item :label="$t('my_password_current')" prop="passwordCurrent">
          <a-input-password
            type="password"
            v-model="myform.passwordCurrent"
            :placeholder="$t('my_password_current_placeholder')"
          />
        </a-form-model-item>

        <a-form-model-item
          :label="$t('my_password_new')"
          prop="newPwd"
          :help="$t('com_form_password_help')"
        >
          <a-input-password
            type="password"
            v-model="myform.newPwd"
            :placeholder="$t('my_password_new_placeholder')"
          />
        </a-form-model-item>

        <a-form-model-item :label="$t('my_password_new_confirm')" prop="confirmNewPwd">
          <a-input-password
            type="password"
            v-model="myform.confirmNewPwd"
            :placeholder="$t('my_password_new_confirm_placeholder')"
          />
        </a-form-model-item>

        <a-form-model-item label=" " :colon="false" style="text-align:right">
          <a-button
            type="primary"
            style="margin-top:15px"
            :loading="passwordFormLoading"
            :disabled="baseFormLoading || emailFormLoading"
            @click="updateMyPassword"
          >
            {{ $t('my_password_btn') }}
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import { checkPassword } from '@/libs/validator';
import * as API from '@/api/my';
import { UserInfo } from '@/api/common';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isSuperAdmin']),
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      myform: {
        name: undefined,
        avatar: undefined,
        roleName: undefined,
        customerName: undefined,
        nickName: undefined,
        contact: undefined,
        email: undefined,
        password: undefined,

        // 用于更改密码
        passwordCurrent: undefined,
      },

      // 更新基础信息
      baseFormRules: {},
      baseFormLoading: false,

      // 更新邮箱
      updateEmailRules: {
        email: [
          {
            required: true,
            message: this.$t('my_form_email_placeholder'),
            trigger: 'change',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('my_email_password_help'),
            trigger: 'change',
          },
        ],
      },
      emailFormLoading: false,

      // 更新密码
      updatePasswordRules: {
        passwordCurrent: [
          {
            required: true,
            message: this.$t('my_password_current_placeholder'),
            trigger: 'change',
          },
        ],
        newPwd: [
          {
            required: true,
            message: this.$t('my_password_new_placeholder'),
            trigger: 'change',
          },
          { validator: this.validatePassword, trigger: 'change' },
        ],
        confirmNewPwd: [
          {
            required: true,
            message: this.$t('my_password_new_confirm_placeholder'),
            trigger: 'change',
          },
          { validator: this.comfrimPassword, trigger: 'change' },
        ],
      },
      passwordFormLoading: false,

      // 上传图片列表
      fileList: [],
    };
  },
  created() {
    this.getUserSelfInfo();
  },
  methods: {
    // 获取自己的信息
    getUserSelfInfo() {
      API.MyInfo()
        .then(res => {
          if (res.code === 0) {
            if (res.data) {
              if (res.data.userInfo) {
                Object.keys(this.myform).forEach(key => {
                  if (key === 'avatar') {
                    this.myform[key] = res.data.userInfo[key] ? [res.data.userInfo[key]] : [];
                  } else {
                    this.myform[key] = res.data.userInfo[key];
                  }
                });
              }
              // 所属客户
              if (res.data.customerInfo) {
                this.myform.customerName = res.data.customerInfo.name || '--';
              }

              if (res.data.roleInfo) {
                // role info
                this.myform['roleName'] = res.data.roleInfo.name || '--';
              }
            }
          }
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
        });
    },

    // 更新基础信息
    updateMyBaseInfo() {
      this.$refs.formElementBase.validate(valid => {
        if (valid) {
          this.baseFormLoading = true;
          const params = {
            nickName: this.myform.nickName,
            contact: this.myform.contact,
          };
          if (this.myform.avatar && this.myform.avatar[0]) {
            params.avatar = this.myform.avatar[0];
          } else {
            params.avatar = '';
          }

          API.EditMyBaseInfo(params)
            .then(res => {
              if (res && res.code === 0) {
                this.$message.success(this.$t('com_msg_edit_success'));
                this.fileList = [];

                // 更新
                this.getUserSelfInfo();
                this.getUserInfo();
              }
            })
            .finally(() => {
              this.baseFormLoading = false;
            });
        }
      });
    },

    // 更新邮箱，确认密码
    updateMyEmailConfirmPassword() {
      this.showPassword();
    },

    // 更新邮箱
    updateMyEmail() {
      this.$refs.formElementEmail.validate(valid => {
        if (valid) {
          this.emailFormLoading = true;
          const params = {
            email: this.myform.email,
            password: this.myform.password,
          };

          API.EditMyEmail(params)
            .then(res => {
              if (res && res.code === 0) {
                this.$message.success(this.$t('com_msg_edit_success'));
                // 更新
                this.getUserSelfInfo();
                this.visible = false;
              }
            })
            .finally(() => {
              this.emailFormLoading = false;
            });
        }
      });
    },

    // 更新密码
    updateMyPassword() {
      this.$refs.formElementPassword.validate(valid => {
        if (valid) {
          this.passwordFormLoading = true;
          const params = {
            oldPwd: this.myform.passwordCurrent,
            newPwd: this.myform.newPwd,
          };

          API.EditMyPassword(params)
            .then(res => {
              if (res && res.code === 0) {
                this.$message.success(this.$t('com_msg_edit_success'));
              }
            })
            .finally(() => {
              this.passwordFormLoading = false;
            });
        }
      });
    },

    // 验证新密码
    validatePassword(rule, value, callback) {
      if (!value) {
        callback();
      }
      if (!checkPassword(value)) {
        callback(this.$t('my_password_error1'));
        return;
      }
      callback();
    },

    // 确认新密码
    comfrimPassword(rule, value, callback) {
      if (value && value !== this.myform.newPwd) {
        callback(this.$t('my_password_error2'));
      } else {
        callback();
      }
    },

    // 更新用户信息
    getUserInfo() {
      UserInfo().then(res => {
        if (res && res.data && res.code === 0) {
          if (res.data && res.data.user && res.data.user.userName) {
            // 当前用户
            this.$store.commit('setUserInfo', res.data);
          }
        }
      });
    },

    showPassword() {
      this.visible = true;
    },
    handleOk(_e) {},
    handleCancel(_e) {
      this.myform.password = undefined;
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.my-info {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  height: 100%;
  overflow-y: auto !important;
  background: #fff;
  margin: 0 auto;
  width: 70%;
  border-radius: 12px;

  .my-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    width: 100%;
    max-width: 900px;
    padding: 20px;

    span {
      font-size: 12px;
      font-weight: normal;
      padding: 0 0 0 10px;
      color: #999;
    }
  }

  .my-form {
    width: 100%;
  }

  .my-btn {
    text-align: right;
  }

  .my-hr {
    height: 1px;
    background: #eee;
    overflow: hidden;
    width: 100%;
  }

  .my-avatar-main {
    display: flex;
    padding: 0 20px 0 30px;

    .my-avatar-img {
      img {
        width: 100px;
        height: 100px;
        border-radius: 100%;
      }
    }
    .my-avatar-upload {
      padding: 0 0 0 50px;
    }
  }
}
</style>
